import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_TENANT_ID ?? '';
const clientId = import.meta.env.VITE_CLIENT_ID ?? '';
const apiScope = import.meta.env.VITE_API_SCOPE ?? '';
const redirectUri = import.meta.env.VITE_REDIRECT_URI ?? window.location.origin;

/**
 * True only when all three Entra config values are present. While false, the
 * app still runs but sign-in is a no-op with a friendly message — useful for
 * spinning up the public pages before the app reg is provisioned.
 */
export const authConfigured: boolean = Boolean(tenantId && clientId && apiScope);

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || 'placeholder-no-auth',
    authority: tenantId
      ? `https://login.microsoftonline.com/${tenantId}`
      : 'https://login.microsoftonline.com/common',
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: apiScope ? [apiScope, 'openid', 'profile', 'email'] : ['openid', 'profile', 'email'],
};

export const tokenRequest = {
  scopes: apiScope ? [apiScope] : [],
};

export const msalInstance = new PublicClientApplication(msalConfig);
